import moment from 'moment';
import {TimetableItem} from '@/interfaces/timetable/TimetableItem';

/** Subtitle of the course dialogs: "KS011 · Klavier · Mi, 08.10. 09:00–09:45" (only the parts that are known) */
export function courseSubtitle(event?: Partial<TimetableItem<any>> | null): string {
    if (!event) {
        return '';
    }
    const course = event.data || {};
    const subject = course.subject && typeof course.subject === 'object' && 'name' in course.subject ? course.subject.name : '';
    const start = event.start ? moment(event.start, 'YYYY-MM-DD HH:mm') : null;
    const end = event.end ? moment(event.end, 'YYYY-MM-DD HH:mm') : null;
    const when = start?.isValid() ? `${start.format('dd, DD.MM. HH:mm')}${end?.isValid() ? `–${end.format('HH:mm')}` : ''}` : '';
    return [course.customId, subject, when].filter(Boolean).join(' · ');
}
